"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk45FFMD6H_js = require('./chunk-45FFMD6H.js');
var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var i = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var i__default = /*#__PURE__*/_interopDefaultLegacy(i);

var n=i__default["default"](chunk45FFMD6H_js.d)`
  line-height: 24px;
`,m=i__default["default"].span`
  box-sizing: border-box;
  height: 24px;
  width: fit-content;
  border-radius: var(--border-radius-small);
  display: flex;
  align-items: center;
  gap: var(--spacing-x-small);
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);

  color: var(--color-neutral-800);
  ${({$badgeColor:o})=>i.css`
    background-color: var(--${o});
    border: 1px solid var(--${o});
  `}

  ${n} {
    max-width: 132px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`,e={Badge:m,Label:n};var u={default:{badgeColor:"color-neutral-100",iconColor:"color-neutral-700"},active:{badgeColor:"color-green-100",iconColor:"color-green-600"},info:{badgeColor:"color-blue-100",iconColor:"color-blue-600"},attention:{badgeColor:"color-yellow-100",iconColor:"color-yellow-600"},critical:{badgeColor:"color-pink-100",iconColor:"color-pink-600"},featured:{badgeColor:"color-blurple-100",iconColor:"color-blurple-600"}},p=({variant:o="default",icon:l,children:r,...c})=>{let{badgeColor:g,iconColor:s}=u[o];return jsxRuntime.jsxs(e.Badge,{$badgeColor:g,...c,children:[l&&jsxRuntime.jsx(chunkPBLNC4OF_js.b,{size:"small",colorToken:s,icon:l}),typeof r=="string"?jsxRuntime.jsx(e.Label,{colorToken:"color-neutral-800",size:"small",weight:"bold",letterSpacing:"regular",children:r}):r]})};p.displayName="Badge";var C=i__default["default"](p)``;

exports.a = C;
